import { MastraClient } from '@mastra/client-js'
import { partner, domain } from './http'
import { getSession } from '../session'

export * from '@mastra/client-js'

export const baseURL = `//${domain}/`

let abortController = new AbortController()

export const mastraClient = new MastraClient({
  baseUrl: baseURL,
  abortSignal: abortController.signal,
  headers: {
    ['X-CRM-Subdomain']: partner,
    ['X-CRM-Base-Domain']: domain.replace('agents.', ''),
  },
})

export const mastraClentCancel = () => {
  abortController.abort()
  abortController = new AbortController()
  mastraClient.options.abortSignal = abortController.signal
}
export const mastraClientAuth = () => {
  const session = getSession()

  mastraClient.options.headers = { ...mastraClient.options.headers }
  mastraClient.options.headers[
    'X-CRM-Auth-Token'
  ] = `Bearer ${session.accessToken}`
}

export const CRM_AGENT_ID = 'crmAgent'
export const CRMAgent = mastraClient.getAgent(CRM_AGENT_ID)
